module.exports = __webpack_public_path__ + "static/images/envelope.3c6c0137241ac493c01aebf17d2cb59f.svg";